export default __webpack_public_path__ + "static/media/output.a8518aa6.mp3";